import {MiddlewareType} from 'middlewares'

import {StoreActionsType} from 'modules'
import {getHttpRequestId} from 'modules/common/selectors'
import timing from 'utils/timing'
import logBoFHService, {
  BoFHServiceStatus,
  BoFHServiceEndpointNames
} from 'performance/logBoFHService'

import {getCurrentBookingRequestId} from 'utils/bookingRequestId'
import {bookApi} from '@daedalus/core/src/booking/services/bookApi'

const requestsTiming = timing()

const middleware: MiddlewareType =
  store => next => async (action: StoreActionsType) => {
    const {getState} = store
    const state = getState()
    const httpRequestId = getHttpRequestId(state)
    const bookingRequestId = getCurrentBookingRequestId()

    next(action)

    if (bookApi.endpoints.createBooking.matchPending(action)) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {payment, rooms, ...restPayload} =
        action?.meta?.arg?.originalArgs?.payload

      requestsTiming.start('bookOfferCreation')
      const loggedPayload = {
        ...restPayload,
        rooms: rooms.map(room => ({
          guests: room.guests,
          specialRequest: room.specialRequest
        }))
      }

      logBoFHService(
        BoFHServiceEndpointNames.BookingCreation,
        BoFHServiceStatus.start,
        {
          params: loggedPayload,
          request_id: httpRequestId,
          booking_request_id: bookingRequestId
        }
      )
    }

    if (bookApi.endpoints.createBooking.matchFulfilled(action)) {
      const timings = requestsTiming.stop('bookOfferCreation')
      const {payload} = action
      logBoFHService(
        BoFHServiceEndpointNames.BookingCreation,
        BoFHServiceStatus.done,
        {
          data: payload,
          timings,
          request_id: httpRequestId,
          booking_request_id: bookingRequestId
        }
      )
    }

    if (bookApi.endpoints.createBooking.matchRejected(action)) {
      const timings = requestsTiming.stop('bookOfferCreation')
      logBoFHService(
        BoFHServiceEndpointNames.BookingCreation,
        BoFHServiceStatus.error,
        {
          error: action?.payload?.data?.details,
          timings,
          request_id: httpRequestId,
          booking_request_id: bookingRequestId
        },
        'error'
      )
    }
  }

export default middleware
